import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Copy } from '@honda-canada/design-system-react';
const PaymentCalculatorSectionTitle = ({ children, ...others }) => (_jsx(Copy, { as: "h5", mb: "m", mr: "xxs", fontFamily: "bold", letterSpacing: "small", fontSize: ['14px', '16px'], lineHeight: ['22px', '26px'], ...others, children: children }));
export default PaymentCalculatorSectionTitle;
